export default function PubTV() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="pubtv-icon"
      width="11"
      height="11"
      fill="none"
      viewBox="0 0 11 11"
    >
      <path d="M1.55 7.567h1.032a.996.996 0 00-.303-.73.993.993 0 00-.73-.304v1.034zm1.833 0h.749a2.49 2.49 0 00-.756-1.828 2.486 2.486 0 00-1.826-.756v.75c.507 0 .94.178 1.297.536.358.357.536.79.536 1.298zm1.55 0h.748c0-.569-.107-1.105-.322-1.609a4.143 4.143 0 00-.885-1.317 4.146 4.146 0 00-1.317-.885 4.046 4.046 0 00-1.607-.323v.75c.938 0 1.736.329 2.395.988s.988 1.457.988 2.396zM3.099 10.15V9.117H1.033a.995.995 0 01-.73-.304.993.993 0 01-.303-.73v-6.2c0-.284.101-.528.304-.73A.993.993 0 011.033.85h8.264c.284 0 .527.1.73.303a.993.993 0 01.303.73v6.2a.996.996 0 01-.304.73.993.993 0 01-.729.304H7.231v1.033H3.099z" />
    </svg>
  );
}
